import actions from './actions';

const { requestFloorLayoutsBegin } = actions;

export default {
  requestFloorLayoutsBegin,
};
